// JS file for MemberList

import u from '@main';
import '@vendor/swiper/swiper-bundle.min.js?99141f134376ef9b3794c167';
u.importCSS('@vendor/swiper/swiper-bundle.min.css');

// get child id and slide id
const childId = u.data('childId');
let slideId = 0;

if ( childId !== null) {
  slideId = $('[data-child-id="' + childId + '"]').index();
}

const category_swiper = new Swiper('.js-category-swiper', {
  initialSlide: slideId,
  slidesPerView: 3,
  spaceBetween: 20,
  navigation: {
    nextEl: ".js-category-btn--next",
    prevEl: ".js-category-btn--prev"
  },
  breakpoints: {
    768: {
      slidesPerView: 4,
      spaceBetween: 10
    },
    1200: {
      slidesPerView: 6,
      spaceBetween: 10
    }
  },
  on: {
    init: function (swiper) {
      setTimeout(() => {
        $('.js-category-swiper').css('opacity',1);
      }, 100);

      swiper.slides.forEach(function (e, i) {
        if (e.classList.contains("active")) {
          swiper.slideTo(i, 300);
        }
      });
    },
  },
});



// 以下製作 swiper 視窗中最右方的文字顏色有漸層的效果
function addActive1 () {
  let activeItem = $('.swiper-slide-active');
  if ( window.innerWidth >= 1200 ) {
    activeItem.next().next().next().next().next().addClass('swiper-slide-active1');
  } else if ( window.innerWidth < 1200 && window.innerWidth >= 768 ) {
    activeItem.next().next().next().addClass('swiper-slide-active1');
  } else {
    activeItem.next().next().addClass('swiper-slide-active1');
  }
  $('.nav-link.active').parent('.swiper-slide-active').css({'-webkit-text-fill-color':"#7f6ae7"});
};

window.addEventListener('load', addActive1);

window.addEventListener('resize', (e)=>{
  $('.swiper-slide-active1').removeClass('swiper-slide-active1');
  addActive1();
});

$('.js-category-btn--next').on('click', function () {
  $('.swiper-slide-active1').removeClass('swiper-slide-active1');
  addActive1();
  $('.nav-link.active').parent('.swiper-slide-active').css({'-webkit-text-fill-color':"#7f6ae7"});
});

$('.js-category-btn--prev').on('click', function () {
  $('.swiper-slide-active1').removeClass('swiper-slide-active1');
  addActive1();
  $('.nav-link.active').parent('.swiper-slide-active').css({'-webkit-text-fill-color':"#7f6ae7"});
});
